module.exports = __webpack_public_path__ + "static/media/terms.9b9e8139.pdf";